import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { interval, Observable, Subscription } from 'rxjs';
import { isDefined, NavItem } from '@slb-dls/angular-material/shared';
import { SlbNotificationItem } from '@slb-dls/angular-material/notifications-panel';
import { RunningUserContext } from '../../core/models/running-user-context.model';
import { Store, select } from '@ngrx/store';
import { UpdateSessionService } from '../../core/services/update-session.service';
import { BrowserStorageService } from '../../core/utilities/browser-storage.utility';
import { LoginService } from '../../core/services/login.service';
import { fromRoot } from 'src/app/core/utilities/ngrx-loader.utility';
import { OidcSecurityService } from '@delfi-gui/angular-auth-oidc-client';
import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AppComponent implements OnDestroy {
    loader$: Observable<number>;
    runningUserContext!: RunningUserContext;
    notificationCount = 10;
    notificationItems: SlbNotificationItem[] = [];
    showHeader = true;
    pageTitle = 'developer-portal';
    secondaryLinks: NavItem[] = [
        {
            'label': 'Default',
            'routerLink': [
                '',
                'home',
            ],
        },
        {
            'label': 'Page 1',
            'routerLink': [
                '',
                'notifications',
            ],
        },
        {
            'label': 'Page 2',
            'routerLink': [
                '',
                'themes',
            ],
        },
        {
            'label': 'Page 3',
            'routerLink': [
                '',
                'notifications',
            ],
        },
    ];

    private routerSubscription = Subscription.EMPTY;

    constructor(
        public appConfigurationService: AppConfigurationService,
        private router: Router,
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
        private loaderStore: Store<{ loader: number }>,
        public oidcSecurityService: OidcSecurityService,
        private sessionService: UpdateSessionService,
        private loginService: LoginService,
        private sessionStorage: BrowserStorageService,
    ) {
        this.loader$ = this.loaderStore.pipe(select('loader'));
        matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/svg-symbols.svg'));
        matIconRegistry.addSvgIcon('developer-docs', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/developer-docs.svg'));
        matIconRegistry.addSvgIcon('product-update', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/product-update.svg'));
        matIconRegistry.addSvgIcon('product-new-release', domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/product-new-release.svg'));

        this.routerSubscription = router.events.pipe(
            filter(e => e instanceof RoutesRecognized),
            map(e => e as RoutesRecognized))
            .subscribe(e => this.onRouteChange(e));
    }

    async ngOnInit() {
        this.checkHandler();
        if (this.sessionStorage.get(BrowserStorageService.accessTokenKey)) {
            const access_token = this.oidcSecurityService.getAccessToken();

            this.oidcSecurityService.checkAuth().subscribe((auth) => {
                if (auth.isAuthenticated && (this.sessionStorage.get(BrowserStorageService.accessTokenKey) !== access_token)) {
                    this.sessionStorage.set(BrowserStorageService.accessTokenKey, access_token);
                }
                this.sessionService.getUsersCurrentContext().subscribe((resp) => {
                    this.runningUserContext = this.sessionStorage.get(BrowserStorageService.runningUserContextKey);
                    if (this.runningUserContext.account.accountId !== resp.account.accountId ||
                        this.runningUserContext.account.internal !== resp.account.internal ||
                        this.runningUserContext.contract.contractId !== resp.contract.contractId ||
                        this.runningUserContext.department.departmentId !== resp.department.departmentId) {
                        this.sessionStorage.set(BrowserStorageService.runningUserContextKey, resp);
                        setTimeout(() => {
                            this.reloadWindow();
                        }, 1000);
                    }
                })
            });
        }

    }

    reloadWindow() {
        window.location.reload()
    }

    ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
    }

    private onRouteChange(event: RoutesRecognized): void {
        const data: any = event.state.root.firstChild?.data;
        this.showHeader = isDefined(data.showHeader) ? data.showHeader : true;
        this.pageTitle = data.title;
        this.loaderStore.dispatch(fromRoot.clearAllLoader()());
    }

    checkHandler() {
        interval(3000).subscribe(async _ => {
            // /!\ here be dragons! /!\
            //  During token renew procedure with multiple tabs open
            //  library tries to update value of it's internal state
            //  During this update one of tabs can start checking 
            //  if we are loged in and fail.
            //  This fail will cause all tabs to logged out.
            if (!(this.loginService.isUserAuthenticated().success) && !this.router.url.startsWith('/auth/access-denied')) {
                this.router.navigateByUrl('/auth/logout');
            }
        });
    }
}